import { render, staticRenderFns } from "./AppyDetail.vue?vue&type=template&id=c2485b38&scoped=true&"
import script from "./AppyDetail.vue?vue&type=script&lang=js&"
export * from "./AppyDetail.vue?vue&type=script&lang=js&"
import style0 from "./AppyDetail.vue?vue&type=style&index=0&id=c2485b38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2485b38",
  null
  
)

export default component.exports